import type { JobPosting } from '@rumblefish/strapi/strapiTypes';
import type { GetStaticPaths, GetStaticProps } from 'next';
import {
  fetchBlogPosts,
  fetchJobPostings,
} from '../../utils/api/fetchStrapiData';
import JobPost from '../../views/jobPost';

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const jobPostings = await fetchJobPostings();
  const blogPosts = await fetchBlogPosts();
  const slug = params?.slug || '';
  const jobPost = jobPostings.find((jobPost) => jobPost.slug === slug);

  return {
    props: { jobPost, blogPosts },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const jobPosting: JobPosting[] = await fetchJobPostings();

  const paths = jobPosting.map((jobPost) => ({
    params: { slug: jobPost.slug || '' },
  }));

  return {
    fallback: false,
    paths,
  };
};

export default JobPost;
